import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { getTwoDecimalPlaces } from "../../../utils";
import TableHead from "../../../components/CsplTable/TableHead";

const columns = [
  {
    label: "Particulars",
    className: "column-planName col-md-4",
    columnName: "particulars",
  },
  {
    label: "Opening balance for the period",
    className: "column-status col-md-3",
    columnName: "openingBalance",
  },
  {
    label: "Transactions for the period",
    className: "column-status col-md-3",
    columnName: "transactionsForPeriod",
  },
  {
    label: "Closing balance",
    className: "column-status col-md-3",
    columnName: "closingBalance",
  },
];
const data = [
  {
    particulars: "Contributions for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Loan Repayment for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Rollover In the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Transfers for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
const data2 = [
  {
    particulars: "Loans for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Disbursement/Withdrawal for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Fees payable for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Taxes payable for the period",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];

const totalAvailableBalance = {
  particulars: "total available net balance",
  openingBalance: 340123,
  transactionsForPeriod: 102123,
  closingBalance: 442246,
};
const investmentAccount = {
  particulars: "Investments purchased/sold for the period",
  openingBalance: 340123,
  transactionsForPeriod: 102123,
  closingBalance: 442246,
};
export const ParticipantStatementTable = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className="table-width-25">{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th className="table-sub-header">Money In</Table.Th>
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}

        <Table.Tr>
          <Table.Th className="table-sub-header">Money Out</Table.Th>
        </Table.Tr>
        {data2.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className="table-width-25 table-total-value">
                {totalAvailableBalance[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className="table-width-25 table-total-value">
                ${getTwoDecimalPlaces(totalAvailableBalance[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className="table-width-25 table-total-value">
                {investmentAccount[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className="table-width-25 table-total-value">
                ${getTwoDecimalPlaces(investmentAccount[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};
